<template>
  <portal to="modals">
    <div v-if="visible" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
      <div
        class="bg-white rounded-lg p-6 shadow-lg text-center"
        :style="modalStyle"
      >
        <div class="mb-4 text-base font-semibold whitespace-pre-line">
          <slot>
            {{ message }}
          </slot>
        </div>
        <template v-if="!$slots.default">
          <!-- 삭제 진행 중일 때 -->
          <div v-if="isDeleting" class="flex justify-center items-center gap-3">
            <svg class="animate-spin h-5 w-5 text-gray-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
            </svg>
            <span class="text-gray-600">삭제 중...</span>
          </div>
          <!-- 일반 상태일 때 -->
          <div v-else class="flex justify-center gap-4">
            <button
              class="px-3 py-1 bg-blue-100 hover:bg-blue-200 rounded"
              @click="$emit('confirm')"
              title="확인"
            >확인</button>
            <button
              v-if="type === 'confirm'"
              class="px-3 py-1 bg-blue-100 hover:bg-blue-200 rounded"
              @click="$emit('cancel')"
              title="취소"
            >취소</button>
          </div>
        </template>
      </div>
    </div>
  </portal>
</template>

<script>
export default {
  name: 'AlertModal',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'alert' // 'alert' | 'confirm'
    },
    size: {
      type: String,
      default: 'default', // 'default' | 'wide'
      validator: v => ['default', 'wide'].includes(v)
    },
    isDeleting: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    modalStyle() {
      return {
        minWidth: '100px',
        maxWidth: '90vw',
        width: this.size === 'wide' ? '800px' : '400px'
      }
    }
  }
}
</script>

<style scoped>
</style> 